// Aviso de privacidad que se muestra ANTES de guardar una venta con CURP.
// BORRADOR: debe revisarlo un abogado antes de usarse con clientes reales
// (ver docs/PROGRESO.md). Cuando exista /privacidad (cierre del Plan 1), enlazarlo aquí.
export const PRIVACY_NOTICE_VERSION = 'borrador-2026-10';

export const privacyNoticeParagraphs = (businessName) => [
  `Responsable: ${businessName || 'la empresa que te vende esta actividad'}, que registra la venta a través de la plataforma BokerHub.`,
  'Datos que se piden: el nombre y el CURP de cada persona que asistirá. El CURP identifica de forma única a una persona.',
  'Para qué se usan: identificar y registrar a las personas que participarán en esta actividad, según lo que la empresa necesita para operarla. No se usan para publicidad.',
  'Cómo se protegen: el CURP se guarda cifrado, se muestra enmascarado en pantalla y no se incluye en los reportes de ventas salvo que el dueño de la empresa lo pida de forma expresa.',
  'Tus derechos: puedes pedir acceder a tus datos, corregirlos, cancelarlos u oponerte a su uso, solicitándolo a la empresa o a BokerHub.',
];

export const PRIVACY_CHECKBOX_LABEL =
  'El cliente leyó este aviso y acepta que se registren sus datos y los de sus acompañantes.';

// Cuando el propio cliente reserva en línea (Checkout) y acepta por sí mismo.
export const PRIVACY_CHECKBOX_LABEL_SELF =
  'Leí este aviso y acepto que se registren mis datos y los de mis acompañantes.';
